import { gql } from 'graphql-request'

const getMentorData = gql`
  query getMentorData($lang: [Locale!]!, $id: ID) {
    mentor(locales: $lang, where: { id: $id }) {
      id
      title: firstName
      lastName
      shortDescription
      aboutMentor
      videoLink
      gender
      avatarForVideo {
        url(transformation: { document: { output: { format: webp } } })
      }
      videoThumbnail {
        url(transformation: { document: { output: { format: webp } } })
      }
      implantType
      text {
        html
      }
      hearingJourneyNew(first: 50) {
        id
        title
        description {
          html
        }
      }
      location
      speakingLanguages
      whatsappNumber
    }
  }
`
export default getMentorData
